import { type ComponentPropsWithoutRef } from "react";
import { LANDING_PAGE_URL } from "../config/site";
import { trackRegisterClick } from "../utils/analytics";

type RegisterLinkProps = ComponentPropsWithoutRef<"a"> & {
  section: string;
  label?: string;
};

export function RegisterLink({
  section,
  label,
  href = LANDING_PAGE_URL,
  onClick,
  children,
  target = "_blank",
  rel = "noopener noreferrer",
  ...props
}: RegisterLinkProps) {
  return (
    <a
      href={href}
      target={target}
      rel={rel}
      {...props}
      onClick={(e) => {
        trackRegisterClick(section, label ?? (typeof children === "string" ? children : undefined));
        onClick?.(e);
      }}
    >
      {children}
    </a>
  );
}
